import React from 'react';
import './DashboardPageHeader.css';

export type DashboardPageHeaderProps = {
  title: string;
  description?: React.ReactNode;
  /** Bootstrap icon classes, e.g. `bi bi-calendar-event` */
  icon?: string;
  actions?: React.ReactNode;
  /** Extra classes on the toolbar shell (e.g. `events-page-toolbar`, `committee-page__toolbar ps-0`) */
  className?: string;
  /** Filters, badges, or other controls below the title row */
  children?: React.ReactNode;
};

/**
 * Standard dashboard page title area: white card strip matching Events / Projects toolbars.
 */
export default function DashboardPageHeader({
  title,
  description,
  icon,
  actions,
  className = '',
  children,
}: DashboardPageHeaderProps) {
  return (
    <div
      className={`dashboard-page-toolbar bg-white rounded shadow-sm border mb-3 pt-3 pe-3 pb-3 ps-3 ${className}`.trim()}
    >
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2">
        <div className="min-w-0">
          <h2 className="h5 mb-1 fw-bold d-flex align-items-center gap-2">
            {icon ? <i className={`${icon} text-primary`} aria-hidden /> : null}
            {title}
          </h2>
          {description != null && description !== '' && (
            <div className="text-muted small mb-0 dashboard-page-header__description">{description}</div>
          )}
        </div>
        {actions != null && <div className="flex-shrink-0">{actions}</div>}
      </div>
      {children != null && <div className="dashboard-page-header__children">{children}</div>}
    </div>
  );
}
